/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { SplashLayout } from "Views/scaffolding/layouts";

/** Renders the splash page. */
export class Splash extends React.Component<{}, never> {
  /** Renders the splash page to the DOM. */
  render(): JSX.Element {
    return <SplashLayout></SplashLayout>;
  }
}
